export enum ExpSplitVipBenefits {
  A = 'exp_vip_benefits_on_registration_a',
  B = 'exp_vip_benefits_on_registration_b',
}
